module.exports = __webpack_public_path__ + "img/mv.a2b52a71.svg";